import { render } from "./EditRulesSet.vue?vue&type=template&id=078b08d8"
import script from "./EditRulesSet.vue?vue&type=script&lang=js"
export * from "./EditRulesSet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__